<template>
  <v-select
    :disabled="disabled"
    :items="indicadores"
    v-model="indicador"
    item-text="displayName"
    item-value="key"
    prepend-inner-icon="map"
    append-icon="keyboard_arrow_down" 
    persistent-hint
    :hint="$t('selecciona.indicador')"
  ></v-select>
</template>

<script>
import locales from '@/locales'

/**
 * Componente para seleccionar el indicador ambiental
 */
export default {
  props: ['disabled'],
  computed: {
    indicador: {
      get() {
        const key = this.$store.getters.indicador

        if(key == null) {
          return ''
        }
        
        return {
          key,
          displayName: this.$t(`indicadores.${key}`)
        }
      },
      set(indicador) {
        this.$store.dispatch('changeIndicador', indicador)
      }
    },

    indicadores() {
      return this.$store.getters.indicadoresKeys.map(key => ({
          key,
          displayName: key ? this.$t(`indicadores.${key}`) : ''
      }))
    }
  },
}
</script>




// WEBPACK FOOTER //
// select-indicador.vue?5e6a8894